import * as React from "react"

import {HierarchicalTextBlock} from "@components"


export default function companyBrandColumn() {
    return [{
        name: 'company', label: 'Company',
        options: { display: 'excluded' }
    }, {
        name: 'brand', label: 'Brand',
        options: { display: 'excluded' }
    }, {
        name: '',
        label: 'Company & Brand',
        options: {
            filter: false,
            customBodyRowRender: (value, row ) =>  <HierarchicalTextBlock
                supertitle={'COMPANY: '}
                supertitleValue={row.company}
                title={'BRAND: '}
                titleValue={row.brand}
                subtitle={'LINE'}
                subtitleValue={''}
            />
        }
    }]
}